import { Ability, AbilityBuilder } from '@casl/ability';

const { build } = new AbilityBuilder(Ability);
export const ability = build();
